import { Injectable } from "@angular/core";
import {
  Headers,
  Http,
  RequestOptions,
  Response,
  URLSearchParams
} from "@angular/http";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
@Injectable()
export class TechVendorService {
  selectedSubscriptionType: any = {
    subscriptionId: null,
    accessType: "all",
    firstTimeSubscripe: null
  };
  constructor(private httpClient: HttpClient) {}
  inviteTechVendor(email: string, userId: string, accessToken: string) {
    const params = new HttpParams()
      .set("emailId", email)
      .append("id", userId)
      .append("access_token", accessToken);
    return this.httpClient.get("users/tech-vendor-invitation", {
      params: params
    });
  }
  inviteTechBuyer(email: string, userId: string, accessToken: string) {
    const params = new HttpParams()
      .set("emailId", email)
      .append("id", userId)
      .append("access_token", accessToken);
    return this.httpClient.get("users/tech-buyer-invitation", {
      params: params
    });
  }
  requestSubscription(userId: string, accessToken: string) {
    const params = new HttpParams()
      .set("userId", userId)
      .append("access_token", accessToken);
    return this.httpClient.get("users/request-subscription", {
      params: params
    });
  }

  addUserToSubscription(userId: string, email: string, access_token: string) {
    const params = new HttpParams()
      .set("userId", userId)
      .append("email", email)
      .append("access_token", access_token);
    return this.httpClient.post(
      "users/add-to-subscription",
      {},
      { params: params }
    );
  }

  getTechVendorDetails(id: string) {
    return this.httpClient.get(`users/${id}/profile`);
  }

  updateVendorDetails(id: string, vendorDetails) {
    return this.httpClient.patch(`users/${id}`, vendorDetails);
  }

  updateCompanyDetails(companyDetails) {
    return this.httpClient.patch(`Addresses`, companyDetails);
  }
  getViewall() {
    return this.httpClient.get("VendorAccessibleResearchViews/domain-get-list");
  }

  getRecentlyViewedResearch(query) {
    let filter = new HttpParams().set("filter", JSON.stringify(query));
    if (query.search) {
      filter = filter.append("search", query.search);
    }
    if (query.sort) {
      filter = filter.append("sort", JSON.stringify(query.sort));
    }
    if (query.limit) {
      filter = filter.append("limit", (query.limit));
    }
    if (query.skip) {
      filter = filter.append("skip", (query.skip));
    }
    if (query.techDomainId) {
      filter = filter.append("techDomainId", (query.techDomainId));
    }
    return this.httpClient.get("VendorAccessibleResearchViews/research-get-list", { params: query });
  }

  getSubscriptionFAQList() {
    return this.httpClient.get("SubscriptionPackages/faq");
  }

  techDomainsForSubscription() {
    return this.httpClient.get("SubscriptionPackages/tech-domains");
  }

  regionsCountryForSubscription(domains: any) {
    return this.httpClient.post(
      "SubscriptionPackages/tech-domains/regions",
      domains
    );
  }

  getAllCountries(filter: any) {
    return this.httpClient.get("Countries", { params: filter });
  }
  getAllCountryRegionMappingList() {
    return this.httpClient.get("Countries/getList");
  }

  getMyPurchasedSubscription() {
    const expired = false;
    return this.httpClient.get(
      `SubscriptionMasters/my-purchased-subscriptions/${expired}`
    );
  }
  getMyExpiredSubscriptions() {
    const expired = true;
    return this.httpClient.get(
      `SubscriptionMasters/my-purchased-subscriptions/${expired}`
    );
  }
  getMyCompanySubscriptions() {
    const expired = true;
    return this.httpClient.get(
      `SubscriptionAllocations/requestable-company-subscription`
    );
  }
  getInvitedSubscriptions(expired: boolean) {
    return this.httpClient.get(
      `SubscriptionAllocations/my-company-purchase/${expired}`
    );
  }
  getMyPendingRequest() {
    return this.httpClient.get(
      `SubscriptionAllocations/approval-requested-list`
    );
  }
  getSubscriptionInvoices(
    userId?: string,
    status?: string,
    skip?: number,
    limit?: number
  ) {
    const filter: any = {};
    filter.filter = JSON.stringify({
      where: { status: status, userId: userId },
      order: "createdAt DESC",
      skip: skip,
      limit: limit
    });
    return this.httpClient.get(`PendingSubscriptions`, { params: filter });
  }

  checkSubscriptionName(subscriptionName: any) {
    let filter: any = {};
    filter.name = subscriptionName;
    return this.httpClient.get("SubscriptionMasters/exists", {
      params: filter
    });
  }

  searchSubscription(terms: Observable<string>) {
    return terms
      .debounceTime(400)
      .distinctUntilChanged()
      .switchMap(term => this.checkSubscriptionName(term));
  }

  startSubscription(id: string, start?: boolean) {
    return this.httpClient.patch(
      `SubscriptionMasters/start-subscription/${id}?start=${start}`,
      {}
    );
  }

  getUsersUnderDomain(email?: string) {
    return this.httpClient.get(
      `SubscriptionAllocations/same-email-domain-users`
    );
  }

  subscriptionAllocationsGetList(filter: any) {
    return this.httpClient.get("SubscriptionAllocations", { params: filter });
  }

  donateTokens(userId_Token: any) {
    return this.httpClient.post(
      "TokenSubscriptions/donate-tokens",
      userId_Token
    );
  }

  addUser(data) {
    return this.httpClient.post(
      `SubscriptionAllocations/set-access-permission`,
      data
    );
  }

  getAccessType() {
    return this.selectedSubscriptionType;
  }

  requestAccessOnSubscription(subscriptionId: string) {
    return this.httpClient.post(
      `SubscriptionAllocations/request-access/${subscriptionId}`,
      {}
    );
  }

  modifyUserAccess(subscription: any) {
    return this.httpClient.patch(
      `SubscriptionAllocations/user-access/${subscription.id}`,
      {}
    );
  }

  updateSubscriptionName(id: string, name: string) {
    return this.httpClient.patch(
      `SubscriptionMasters/subscription-name/${id}?name=${name}`,
      {}
    );
  }

  updateSubscriptionDate(id: string, date: string, start: boolean) {
    return this.httpClient.patch(
      `SubscriptionMasters/start-subscription/${id}?start=${start}&startDate=${date}`,
      {}
    );
  }

  getAllSubscribedUsers(id: string) {
    return this.httpClient.get(`SubscriptionAllocations/users/${id}`);
  }

  getUnSubscribedUsers(id: string, key: string) {
    return this.httpClient.get(
      `SubscriptionAllocations/unsubscribed-users/${id}/?search=${key}`
    );
  }

  removeUserFromSubscription(id: string, userId: string) {
    return this.httpClient.delete(
      `SubscriptionAllocations/users/${id}?userId=${userId}`
    );
  }

  inviteUserToSubscription(subscriptionId: string, userId: string) {
    return this.httpClient.post(
      `SubscriptionAllocations/users/${subscriptionId}?userId=${userId}`,
      {}
    );
  }

  inviteNewUserToSubscription(id: string, email: string) {
    return this.httpClient.post(
      `SubscriptionMasters/invite-users/${id}?email=${email}`,
      {}
    );
  }

  updateUserAccess(data: any) {
    return this.httpClient.patch(`SubscriptionAllocations/user-access`, data);
  }
  getAvailableToken() {
    return this.httpClient.get(`TokenTransactionMasters/my-balance-token`);
  }
  assignTokenToUser(data) {
    return this.httpClient.post(
      `TokenTransactionMasters/transfer-tokens`,
      data
    );
  }
  pendingRequestStatus(
    newstatus: string,
    subscriptionMasterId: string,
    assigneeUserId: string
  ) {
    return this.httpClient.patch(
      `SubscriptionAllocations/subscription-access/${newstatus}?subscriptionMasterId=${subscriptionMasterId}&assigneeUserId=${assigneeUserId}`,
      null
    );
  }
  updateSubscriptionOwner(subscriptionMasterId, oldOwnerId, newOwnerId) {
    return this.httpClient.patch(
      `SubscriptionMasters/set-new-owner?subscriptionMasterId=${subscriptionMasterId}&oldOwnerId=${oldOwnerId}&newOwnerId=${newOwnerId}`, {
    });
  }
  updateSubscriptionDomainRegionMapping(subscriptionMasterIdInFocus, packages) {
    let access_token;
    let userDetails;
    if (window.sessionStorage.getItem("userDetails") != null && window.sessionStorage.getItem("userDetails") != "null") {
      userDetails = JSON.parse(
        window.sessionStorage.getItem("userDetails")
      );
      access_token = userDetails.accessToken;
    }
    return this.httpClient.post(
      `SubscriptionMasters/set-package-country?subscriptionMasterId=${subscriptionMasterIdInFocus}&access_token=${access_token}`, packages
      );
  }
  getUnSubscribedUsersOrg(id: string, key: string, organizationId: string) {
    return this.httpClient.get(
      `SubscriptionAllocations/unsubscribed-users-org/${id}/?search=${key}&organizationId=${organizationId}`
    );
  }

  updateVendorCompanyDetails(id: string, companyDetails) {
    return this.httpClient.patch(
      `TechvendorOrganizations/user/${id}`,
      companyDetails
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/main/tech-vendor/shared/services/tech-vendor.service.ts